import { useEffect } from 'react';
import { getActiveUserId } from '@/stores/auth';
import { setPanel } from '@/stores/layout-status';
import { useMessageStore } from '@/stores/message';
import { queryClient } from '@/utils/query-client';

export const useInitUserState = () => {
  const activeUserId = getActiveUserId();

  const initUserState = () => {
    useMessageStore.getState().resetKey();
    queryClient.removeQueries();
    setPanel('message');
  };

  useEffect(() => {
    initUserState();
  }, [activeUserId]);

  return { initUserState };
};
